import { loadScript } from '@gig/magic-common';

const injectEncryptionScript = (env, merchantId) => {
  const prefix = env.indexOf("prod") >= 0 ? "" : "test-";
  return loadScript(`https://${prefix}api.paymentiq.io/paymentiq/api/viq/jscardencrypter/${merchantId}`).then(() => {
    console.log("Encryption script loaded!, URL:", `https://${prefix}api.paymentiq.io/paymentiq/api/viq/jscardencrypter/${merchantId}`);
  }).catch((error) => {
    console.error(error);
  });
};
const getEncryptedCvc = (cvc) => {
  try {
    const enCvv = window.encryptData(cvc);
    return enCvv.toString();
  } catch (error) {
    throw Error("[CCEE] Processing credit card failed.");
  }
};

export { getEncryptedCvc, injectEncryptionScript };
